'use strict';
module.exports = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-modal/~/dom-helpers/util/inDOM.js
// module id = 1805
// module chunks = 0